import React from "react";
import styled from "styled-components/native"
import { themeTools, useBreakpointValue, useColorMode, } from "native-base"

import { VStack } from "~/native-ui/native-base";


export const Col = React.memo(({ xs, md, xl,  lg, sm, colCount = 1, gap = 0, ...props}) => {
    const { colorMode } = useColorMode();
    const flexGrow = useBreakpointValue({
        base: xs ?? 12,
        xl: xl,
        lg: lg,
        md: md,
        sm: sm,
    });


    
    let flexBasis = `${flexGrow * (100 / 12)}%`;
    
    gap = (gap * (colCount - 1)) / colCount;
    if (gap && flexGrow !== 12) flexBasis = `calc(${flexBasis} - ${gap}px)`;

    const colProps = {
            ...props,
            shadow: props.shadow || undefined,
            space: props.space ?? 4,
            flexShrink: props.flex ?? 0,
            borderRadius: props.borderRadius ?? 8,
            borderColor: props.borderColor ?? "muted.200",
            padding: props.padding ?? (props.shadow ? 4 : undefined),
            backgroundColor: props.backgroundColor ?? (!props.shadow ? undefined : themeTools.mode("light.50", "dark.50")({ colorMode })),
            style: {
                flexBasis,
                flexGrow: flexGrow,
                maxWidth: flexBasis,
                // paddingRight: flexGrow >= 12 ? props.padding : props.paddingRight ?? props.padding ?? 4,
            }
    }

    return <StyledCol { ...colProps } />
})

const StyledCol = styled(VStack)`
    ${
        (props) => props.shadow !== 1 
            ?   ""
            :   `
                border-width: 2px;
                border-style: solid;
                box-shadow: none;
            `
        
    }


    ${
        (props) => !(props.shadow)
            ?   ""
            :   `
                align-self: stretch;
            `
        
    }
`;